// Read-only HMRC data status for menus. The dot is decorative: the text carries the state
export default function HmrcDataIndicator({ isOn }: Readonly<{ isOn: boolean }>) {
  return (
    <span className="flex items-center gap-2">
      <span aria-hidden="true" className="flex size-4 items-center justify-center">
        <span className={`size-2.5 rounded-full ${isOn ? 'bg-primary' : 'bg-pipbg-grouped'}`} />
      </span>
      <span>
        HMRC data
        {' '}
        {isOn ? <span className="text-primary">On</span> : 'Off'}
      </span>
    </span>
  );
}
